import { Upload } from 'antd';
import styled from 'styled-components';

export const DraggerWrapper = styled.div`
  display: flex;
  padding: 1rem 0;

  .ant-upload-list {
    width: 100%;
    max-width: 30rem;
    margin-top: 1rem;
  }

  @media (max-width: 768px) {
    max-width: 100%;

    .ant-form-item,
    .ant-upload-list-item-info,
    .ant-upload-list {
      max-width: 100%;
    }

    .ant-upload-list-picture .ant-upload-list-item {
      height: auto;
      font-size: 13px;
    }

    .ant-upload-list-picture .ant-upload-list-item-thumbnail {
      width: 25px;
      height: 25px;
      line-height: 30px;

      .anticon {
        font-size: 18px;
      }
    }

    .ant-btn {
      width: auto;
      max-width: max-content;
      font-size: 12px;
      padding: 10px;
      height: auto;
    }
  }
`;

export const UploadWrapper = styled(Upload)`
  .ant-upload {
    display: flex;
    gap: 1rem;
  }

  @media (max-width: 768px) {
    background-color: red;
    max-width: 100%;

    .ant-upload {
      max-width: 100%;
      gap: 0.5rem;
    }

    .ant-form-item,
    .ant-upload-list-item-info,
    .ant-upload-list {
      max-width: 100%;
    }

    .ant-btn {
      width: auto;
      max-width: max-content;
      font-size: 12px;
      padding: 10px;
      height: auto;
    }

    .ant-upload-list-picture .ant-upload-list-item {
      height: auto;
      font-size: 13px;
    }

    .ant-upload-list-picture .ant-upload-list-item-thumbnail {
      width: 25px;
      height: 25px;
      line-height: 30px;

      .anticon {
        font-size: 18px;
      }
    }
  }
`;
